import { highChartsLib } from '../highChartsLib';
import { chartJsLib } from '../chartJsLib';
import { Platform } from 'react-native';

/* eslint-disable */
const rnMessager =
  Platform.OS === 'web'
    ? 'alert(message);'
    : 'window.ReactNativeWebView.postMessage(message);';

export const js = `
(() => {
      const sendDataToReactNativeApp = (message) => {
        try {
        ${rnMessager}
        } catch (error) {
          console.error('Error in sendDataToReactNativeApp:', error);
        }
      };
     
      const handleError = (error, context) => {
        console.error(\`Error in \${context}:\`, error);
        sendDataToReactNativeApp(JSON.stringify({ error: error.message, context }));
      };
    
      const checkIfChartIsEmpty = (config) => {
        try {
          const dataArray = [...config.data.datasets[0].data].filter(item => typeof item === "number");
          return dataArray.every(item => item === 0);
        } catch (error) {
          handleError(error, 'checkIfChartIsEmpty');
          return true; // Assume empty if there's an error
        }
      };
    
      const createNoDataDiv = (title, canvasHeight) => {
        const div = document.createElement("div");
        const p = document.createElement("p");
        const h3 = document.createElement("h3");
        const emptyP = document.createElement("p");
    
        p.innerText = title;
        h3.innerText = "keine Ergebnisse";
    
        p.classList.add("no-data-title");
        h3.classList.add("no-data");
    
        div.appendChild(p);
        div.appendChild(h3);
        div.appendChild(emptyP);
    
        div.classList.add("no-data-container");
        div.style.height = canvasHeight + 'px';
    
        return div;
      };
    
      const renderChart = (canvas, config, wrapper) => {
        try {
          if (checkIfChartIsEmpty(config)) {
            const div = createNoDataDiv(config.options.title.text, canvas.height);
            wrapper.appendChild(div);
            wrapper.removeChild(canvas);
          } else {
            return new Chart(canvas.getContext('2d'), config);
          }
        } catch (error) {
          handleError(error, 'renderChart');
        }
      };
    
      const setupHighcharts = (highChartConfigs, hidePrint) => {
        try {
          const divs = highChartConfigs.map(({ isEmpty, chartOptions }, i) => {
            const div = document.createElement("div");
            const id = "hg-" + i;
            div.id = id;
            document.body.appendChild(div);
            return { id, data: chartOptions };
          });
    
          divs.forEach(({ id, data }, index) => {
            data.chart.events = {
              load: function() {
                try {
                  if (this.series.length > 0) {
                    this.series[this.series.length - 1].points.forEach((point) => {
                      if (point.graphic && point.graphic.element) {
                        point.graphic.element.setAttribute(
                          'data-testid',
                          point.index + ':' + Math.round(point.y)
                        )
                      }
                    });
                  }
                  if (this.series.length === 0) {
                    this.renderer
                      .text('keine Ergebnisse', this.plotLeft + 55, this.plotTop - 10)
                      .css({
                        color: '#666666',
                        fontSize: '13px',
                      })
                      .add();
                  }
                  
                } catch (error) {
                  handleError(error, 'Highcharts load event');
                }
              }
            };
            Highcharts.chart(id, data);
          });
        } catch (error) {
          handleError(error, 'setupHighcharts');
        }
      };

      const createTable = (individualStats, isSentence) => {
        try {
          const tableContainer = document.createElement("table");
          const tableHeader = document.createElement("thead");
          const tableBody = document.createElement("tbody");
          const tableRow = document.createElement("tr");
          tableHeader.appendChild(tableRow);
          tableContainer.appendChild(tableHeader);
          tableContainer.appendChild(tableBody);
    
          const titles = [isSentence ? "Satz" : "Wort", "Mündliches Benennen", "Auditives Sprachverständnis", "Schriftliches Benennen", "Lesesinnverständnis"];
          titles.forEach(title => {
            const titleTag = document.createElement("th");
            titleTag.innerText = title;
            tableRow.appendChild(titleTag);
          });
    
          individualStats.forEach((stat) => {
            const { print, thumbnail_url, individualDataArray } = stat;
            const rowContainer = document.createElement("tr");
    
            const titleImgContainer = document.createElement("td");
            titleImgContainer.className = "title-img-container";
            const img = document.createElement("img");
            const title = document.createElement("p");
            title.innerText = print;
            title.className = "grid-container-title";
            img.src = thumbnail_url;
            titleImgContainer.appendChild(title);
            titleImgContainer.appendChild(img);
    
            rowContainer.appendChild(titleImgContainer);
            individualDataArray.forEach((data) => {
              const tableData = document.createElement("td");
              const canvasItemWrapper = document.createElement("div");
              canvasItemWrapper.className = "canvasItemWrapper";
              const canvas = document.createElement("canvas");
              canvas.className = "canvas";
              if (checkIfChartIsEmpty(data)) {
                const h3 = document.createElement("h3");
                h3.innerText = "keine Ergebnisse";
                h3.classList.add("no-data-2");
                tableData.appendChild(h3);
              } else {
                canvasItemWrapper.appendChild(canvas);
                renderChart(canvas, data, canvasItemWrapper);
              }
              tableData.appendChild(canvasItemWrapper);
              rowContainer.appendChild(tableData);
            });
            tableBody.appendChild(rowContainer);
          });
    
          return tableContainer;
        } catch (error) {
          handleError(error, 'createTable');
        }
      };
    
      document.addEventListener("DOMContentLoaded", () => {
        let donutCharts = [];
        let showAllWords = false;
        let tableContainer;
        
        const eventEmitter = ${Platform.OS === 'android' ? 'document' : 'window'};
        
        eventEmitter.addEventListener("message", message => {
          try {
            donutCharts.forEach(donutConfig => {
              donutConfig.destroy();
            });
    
            document.getElementById("body").innerHTML = "";
    
            const {
              speakingConfig,
              understandingConfig,
              writingConfig,
              readingConfig,
              highChartConfigs,
              individualStats,
              title,
              showText,
              hideText,
              isSentence,
              hidePrint
            } = JSON.parse(message.data);
    
            // Title implementation
            const titleAndDuration = document.createElement("p");
            titleAndDuration.classList.add("title_duration");
            titleAndDuration.innerHTML = title;
            document.body.appendChild(titleAndDuration);
    
            // Charts js implementation
            const container1 = document.createElement("div");
            container1.className = "container-1";
            const configs = [speakingConfig, understandingConfig, writingConfig, readingConfig];
            configs.forEach((config, index) => {
              const wrapper = document.createElement("div");
              wrapper.className = \`canvasItemWrapper\${index + 1}\`;
              const canvas = document.createElement("canvas");
              canvas.className = \`canvas\${index + 1}\`;
              wrapper.appendChild(canvas);
              container1.appendChild(wrapper);
    
              renderChart(canvas, config, wrapper);
            });
    
            const container2 = document.createElement("div");
            container2.className = "container-2";
            document.body.appendChild(container1);
            document.body.appendChild(container2);
    
            // Highchart implementation
            setupHighcharts(highChartConfigs, hidePrint);
    
            // Table creation
            tableContainer = createTable(individualStats, isSentence);
    
            // Button setup
            const btnContainer = document.createElement("div");
            btnContainer.className = "btn-container";
            const iIcon = new Image();
            iIcon.src = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgZmlsbD0iY3VycmVudENvbG9yIiBjbGFzcz0iYmkgYmktZXllLWZpbGwiIHZpZXdCb3g9IjAgMCAxNiAxNiI+CiAgPHBhdGggZD0iTTEwLjUgOGEyLjUgMi41IDAgMSAxLTUgMCAyLjUgMi41IDAgMCAxIDUgMHoiLz4KICA8cGF0aCBkPSJNMCA4czMtNS41IDgtNS41UzE2IDggMTYgOHMtMyA1LjUtOCA1LjVTMCA4IDAgOHptOCAzLjVhMy41IDMuNSAwIDEgMCAwLTcgMy41IDMuNSAwIDAgMCAwIDd6Ii8+Cjwvc3ZnPg==";
            iIcon.style.width = "30px";
    
            const btnText = document.createElement("p");
            btnText.className = "btn-text";
            btnText.innerText = showText;
            btnContainer.appendChild(iIcon);
            btnContainer.appendChild(btnText);
            btnContainer.onclick = () => {
              showAllWords = !showAllWords;
              if (showAllWords) {
                iIcon.src = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgZmlsbD0iY3VycmVudENvbG9yIiBjbGFzcz0iYmkgYmktZXllLXNsYXNoLWZpbGwiIHZpZXdCb3g9IjAgMCAxNiAxNiI+CiAgPHBhdGggZD0ibTEwLjc5IDEyLjkxMi0xLjYxNC0xLjYxNWEzLjUgMy41IDAgMCAxLTQuNDc0LTQuNDc0bC0yLjA2LTIuMDZDLjkzOCA2LjI3OCAwIDggMCA4czMgNS41IDggNS41YTcuMDI5IDcuMDI5IDAgMCAwIDIuNzktLjU4OHpNNS4yMSAzLjA4OEE3LjAyOCA3LjAyOCAwIDAgMSA4IDIuNWM1IDAgOCA1LjUgOCA1LjVzLS45MzkgMS43MjEtMi42NDEgMy4yMzhsLTIuMDYyLTIuMDYyYTMuNSAzLjUgMCAwIDAtNC40NzQtNC40NzRMNS4yMSAzLjA4OXoiLz4KICA8cGF0aCBkPSJNNS41MjUgNy42NDZhMi41IDIuNSAwIDAgMCAyLjgyOSAyLjgyOWwtMi44My0yLjgyOXptNC45NS43MDgtMi44MjktMi44M2EyLjUgMi41IDAgMCAxIDIuODI5IDIuODI5em0zLjE3MSA2LTEyLTEyIC43MDgtLjcwOCAxMiAxMi0uNzA4LjcwOHoiLz4KPC9zdmc+";
                btnText.innerText = hideText;
                document.body.appendChild(tableContainer);
              } else {
                iIcon.src = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgZmlsbD0iY3VycmVudENvbG9yIiBjbGFzcz0iYmkgYmktZXllLWZpbGwiIHZpZXdCb3g9IjAgMCAxNiAxNiI+CiAgPHBhdGggZD0iTTEwLjUgOGEyLjUgMi41IDAgMSAxLTUgMCAyLjUgMi41IDAgMCAxIDUgMHoiLz4KICA8cGF0aCBkPSJNMCA4czMtNS41IDgtNS41UzE2IDggMTYgOHMtMyA1LjUtOCA1LjVTMCA4IDAgOHptOCAzLjVhMy41IDMuNSAwIDEgMCAwLTcgMy41IDMuNSAwIDAgMCAwIDd6Ii8+Cjwvc3ZnPg==";
                btnText.innerText = showText;
                document.body.removeChild(tableContainer);
              }
            };
    
            document.body.appendChild(btnContainer);
            if (showAllWords) {
              document.body.appendChild(tableContainer);
            }
    
          } catch (error) {
            handleError(error, 'message event handler');
          }
        });
      });
    })();
`;

export const html = `
<!DOCTYPE html>
<html lang="en">
   <head>
      <meta charset="UTF-8" />
      <meta
         name="viewport"
         content="width=device-width, user-scalable=no, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0"
         />
      <meta http-equiv="Content-Security-Policy" content="
      default-src 'none';
      script-src 'self'
      'sha256-RhjyoOx2hTB5bBLSbb93Vs6CDPu0+ZqqoBPs/GiEsOc='
      'sha256-hMjce9yfcC6L2Z2MC0K+CHNnvs0lgPEeWF8kHKD+9e4='
      'sha256-Ey7N4vNtkLsgxK5qYT4lMDpqnbLnctqithJqkuyI3N4='

      'sha256-VW81J0nPPj+DGHcs8tcoFFaClzFLvCNg3Lelk0S1azE='
      'sha256-if/BKFvjJmMS/UEGY3kg+qXWQ/8WSXkMLe1ocFpC+oM='
      'sha256-KWyHr0vAt2ekKbB+POWpl0NndrBbe7QnoOmr1Yx7GQc='
      'sha256-lAbhWvYGVQfFVs+kkforgDEsDcVSdGVJPrUTs0N1Qcg='
      ;
      style-src 'self' 'unsafe-inline';
      img-src https://neolexon-stage-assets.obs-website.eu-de.otc.t-systems.com https://neolexon-assets.obs-website.eu-de.otc.t-systems.com data:;
      connect-src 'none';
 "/>   
      <meta http-equiv="X-UA-Compatible" content="ie=edge" />
      <title>Document</title>
      <style>
          * {
            margin: 0px;
            padding: 0px;
            box-sizing: border-box;
          }

          body {
            padding: 0px 0px 50px 0px;
          }

          .container-1,
          .container-2 {
            width: 100vw;
            display: flex;
            justify-content: space-around;
            padding: 10px;
          }

          .canvasItemWrapper1,
          .canvasItemWrapper2,
          .canvasItemWrapper3,
          .canvasItemWrapper4 {
            width: 25%;
            position: relative;
            display : flex;
            flex-direction : column;
            justify-content : flex-start;
            align-items : center;
          }

          .canvasItemWrapper {
            width: 100%;
          }

          p {
            text-align: center;
            font-size: 10px;
          }

          .no-data-container {
            display : flex;
            flex-direction : column;
            justify-content : space-between;
            align-items : center;
            padding : 10px 0px;
          }

          .no-data-title {
            font-size: 11px;
            font-family: 'Helvetica', sans-serif;
            color: #6B6B6B;
            font-weight: bold;
          }

          .no-data {
            font-size: 11px;
            font-weight: bold;
            font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;
          }

          .no-data-2 {
            font-size: 11px;
            font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;
            min-height : 137px;
          }

          .btn-container {
            background-color: white;
            padding: 0px 10px;
            width: fit-content;
            height: 75px;
            margin: 20px auto;
            display: flex;
            justify-content: center;
            align-items: center;
            border: solid 1px lightgray;
            cursor: pointer;
          }

          .btn-text {
            color: #3a3a3a;
            font-size: 20px;
            font-weight: bold;
            padding: 0px 10px;
            font-family: 'Helvetica', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;
          }

          .title_duration {
            color: #3a3a3a;
            text-align: left;
            font-size: 20px;
            font-family: 'Helvetica';
            padding: 10px 20px;
          }

          .stats-container {
            width: 100%,
              height: fit-content;
          }

          .icon-size {
            font-size: 30px;
          }

          .hide {
            visibility: hidden !important;
            display: none !important;
          }

          ;

          table,
          thead,
          tbody {
            width: 100%;
          }

          thead tr th {
            font-family: 'Helvetica', sans-serif;
            font-size: 1.2 em;
            font-weight: light;
          }

          table {
            border-collapse: collapse;
            table-layout: fixed;
            width: 100%
          }

          .title-img-container {
            text-align: center;
          }

          td {
            width: 20%;
            position: relative;
            padding: 10px;
          }

          td .no-data-2 {
            display : flex;
            justify-content : center;
            align-items : center;
          }

          tbody tr {
            border-top: 1px solid #3a3a3a;
          }

          tbody tr:first-child {
            border: none;
          }

          tbody tr:last-child {
            border-bottom: 1px solid #3a3a3a;
          }

          .grid-container-title {
            font-family: 'Helvetica', sans-serif;
            font-size: 17px;
          }

          .canvas {
            width: 100% !important;
            height: auto !important;
          }

          .custom-symbol {
            width: 2%;
            height: auto;
            transform: none;
          }

          .custom-symbol:hover {
            cursor: pointer;
          }

          /* Hide elements with the class 'no-print' when printing */
          @media print {

            .container-1,
            .container-2,
            .title_duration,
            #hg-0,
            #hg-1,
            #hg-2,
            #hg-3,
            .btn-container,
            table,
            .highcharts-button {
              display: none;
            }

            .printed-chart {
              width: fit-content !important;
              height: fit-content !important;
            }

            .custom-symbol {
              display: none;
            }
          }
      </style>
   </head>
   <body id="body"> 
      <script>
         ${highChartsLib}
      </script>
      <script>
         ${chartJsLib}
      </script>
      <script>
         ${js}
      </script>
   </body>
</html>
`;
/* eslint-enable */
